module.exports = __webpack_public_path__ + "img/Asia.b87764ca.png";